import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const DetailsText = ({ title, text }) => (
  <Box
    display="flex"
    flexDirection={{ xs: 'column', lg: 'row' }}
    alignItems={{ xs: 'flex-start', lg: 'center' }}
    mb={1}
  >
    {title && (
      <Box maxWidth={110}>
        <Typography width={110} variant="h4" color="light-gray-text.main">
          {title}
        </Typography>
      </Box>
    )}
    {text && (
      <Typography variant="h4" color="dark-text.main">
        {text}
      </Typography>
    )}
  </Box>
)

export default DetailsText
